import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DataService {
  httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
  public dataRegistration: any;

  constructor(private http: HttpClient) { }

  getMunicipalities(): Observable<any> {
    return this.http.get(`${environment.api}geo/municipalities`, this.httpOptions);
  }

  getCenters(): Observable<any> {
    return this.http.get(`${environment.api}help-centers`, this.httpOptions);
  }

  getExpressAnswers(): Observable<any> {
    return this.http.get(`${environment.api}poll/express-answers`, this.httpOptions);
  }

  pollExpress(data: any): Observable<any> {
    return this.http.post(`${environment.api}poll/express-answers`, data, this.httpOptions);
  }

  getCivilStatus(): Observable<any> {
    return this.http.get(`${environment.api}catalogs/civil-status`, this.httpOptions);
  }

  getEducationLevels(): Observable<any> {
    return this.http.get(`${environment.api}catalogs/education-levels`, this.httpOptions);
  }

  getQuestionsAnswers(): Observable<any> {
    return this.http.get(`${environment.api}poll/questions-answers`, this.httpOptions);
  }

  storePoll(data: any): Observable<any> {
    return this.http.post(`${environment.api}poll/questions-answers`, data, this.httpOptions);
  }

  setDataRegistration(data) {
    this.dataRegistration = data;
  }
}
